import React, { useState } from 'react';
import { Box, Button, Typography, CircularProgress, TextField, Paper } from '@mui/material';
import axios from 'axios';

const FortnoxReconciliation = () => {
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState('');
  const [errorRows, setErrorRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredRows, setFilteredRows] = useState([]);

    // Search handler (fix missing definition)
    const handleSearch = () => {
      if (!search.trim()) {
        setFilteredRows(errorRows);
        return;
      }
      const lower = search.trim().toLowerCase();
      setFilteredRows(errorRows.filter(row =>
        row.invoiceNumber?.toString().toLowerCase().includes(lower) ||
        row.case?.toLowerCase().includes(lower) ||
        row.debtor?.toLowerCase().includes(lower)
      ));
    };
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setUploadStatus('Please select a file.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      setLoading(true);
      const response = await axios.post('/admin/fortnox-reconciliation/upload', formData);
      setUploadStatus(response.data.message || 'File uploaded successfully!');
      // Filter rows with error
      if (response.data.result && Array.isArray(response.data.result)) {
        const errors = response.data.result.filter(row => row.error && row.error.trim() !== '');
        setErrorRows(errors);
        setFilteredRows(errors);
      } else {
        setErrorRows([]);
        setFilteredRows([]);
      }
      const handleSearch = () => {
        if (!search.trim()) {
          setFilteredRows(errorRows);
          return;
        }
        const lower = search.trim().toLowerCase();
        setFilteredRows(errorRows.filter(row =>
          row.invoiceNumber?.toString().toLowerCase().includes(lower) ||
          row.case?.toLowerCase().includes(lower) ||
          row.debtor?.toLowerCase().includes(lower)
        ));
      };
    } catch (error) {
      setUploadStatus('Upload failed.');
      setErrorRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={6} sx={{ p: 4, maxWidth: 'auto', mx: 'auto', mt: 4, background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
      <Typography variant="h4" mb={2} sx={{ fontWeight: 700, color: '#3f51b5', letterSpacing: 1 }}>Fortnox Reconciliation</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <input type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} style={{ border: '1px solid #3f51b5', borderRadius: 6, padding: '8px', background: '#fff', fontWeight: 500 }} />
        <Button variant="contained" color="primary" onClick={handleUpload} disabled={loading} sx={{ fontWeight: 600, borderRadius: 6, minWidth: 140 }}>
          {loading ? 'Uploading...' : 'Upload & Send'}
        </Button>
        {loading && <CircularProgress size={28} sx={{ color: '#3f51b5' }} />}
      </Box>
      {uploadStatus && <Typography mt={2} sx={{ color: uploadStatus.includes('success') ? '#388e3c' : '#d32f2f', fontWeight: 600 }}>{uploadStatus}</Typography>}
      {errorRows.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Paper elevation={3} sx={{ p: 2, mb: 2, background: 'linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%)' }}>
            <Typography variant="h6" color="error" mb={2} sx={{ fontWeight: 700 }}>Errors</Typography>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Search Invoice/Case/Debtor"
                variant="outlined"
                size="small"
                value={search}
                onChange={e => setSearch(e.target.value)}
                sx={{ background: '#fff', borderRadius: 2 }}
              />
              <Button variant="contained" color="error" onClick={handleSearch} sx={{ fontWeight: 600, borderRadius: 2 }}>Search</Button>
            </Box>
            <Box sx={{ overflowX: 'auto', borderRadius: 2 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px #d32f2f33' }}>
                <thead>
                  <tr style={{ background: '#d32f2f', color: '#fff' }}>
                    <th style={{ padding: '10px', border: 'none', fontWeight: 700, fontSize: '15px' }}>Case</th>
                    <th style={{ padding: '10px', border: 'none', fontWeight: 700, fontSize: '15px' }}>Debtor</th>
                    <th style={{ padding: '10px', border: 'none', fontWeight: 700, fontSize: '15px' }}>Customer Number</th>
                    <th style={{ padding: '10px', border: 'none', fontWeight: 700, fontSize: '15px' }}>Invoice Number</th>
                    <th style={{ padding: '10px', border: 'none', fontWeight: 700, fontSize: '15px' }}>Error</th>
                  </tr>
                </thead>
                <tbody>
                  {(filteredRows.length > 0 ? filteredRows : errorRows).map((row, idx) => (
                    <tr key={idx} style={{ background: '#ffcdd2', borderBottom: '2px solid #d32f2f' }}>
                      <td style={{ padding: '10px', fontWeight: 500 }}>{row.case}</td>
                      <td style={{ padding: '10px', fontWeight: 500 }}>{row.debtor}</td>
                      <td style={{ padding: '10px', fontWeight: 500 }}>{row.customerNumber}</td>
                      <td style={{ padding: '10px', fontWeight: 500 }}>{row.invoiceNumber}</td>
                      <td style={{ padding: '10px', color: '#d32f2f', fontWeight: 700 }}>{row.error}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Box>
          </Paper>
        </Box>
      )}
    </Paper>
  );
};

export default FortnoxReconciliation;